export * from "./pipes/shared-pipes.module";
export * from "./components";
export * from "./directives";
export * from "./modules";
export * from "./guard";
export * from "./pipes";
export * from "./services";
export * from "./reducers";
export * from "./actions";
export * from "./validators"



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/index.ts